import React, { useState } from 'react';
import { Card, Form, Row, Col, Input, Button, Spin, notification } from 'antd';
import { useNavigate } from 'react-router-dom';
import { errHandler } from '../../helper/helper';
import { getLoanPaymentHistory } from "./LoanService";
import '../../Layout/cardStyle.css';

const LoanPaymentHistory = ({
    loginPlaceId,
    branchId,
    branch_name,
}) => {
    const [loading, setLoading] = useState(false);
    const [loanNo, setLoanNo] = useState("");
    const [error, setError] = useState(null);

    const navigate = useNavigate();

    const handleLoanChange = (e) => {
        const value = e.target.value;
        if (value === "" || /^[0-9]+$/.test(value)) {
            setLoanNo(value);
            setError(null);
        } else {
            setError("Please enter numbers only");
        }
    };

    const handleViewHistory = async () => {
        if (!loanNo.trim()) {
            notification.warning({
                message: "Validation Error",
                description: "Please enter a valid Loan Number",
            });
            return;
        }

        setLoading(true);

        try {
            const payload = {
                loanNo: loanNo.trim()
            };

            const response = await getLoanPaymentHistory(payload);

            let loanData = null;
            if (response) {
                if (response.loanNo || response.accNumber) {
                    loanData = response;
                } else if (response.data) {
                    loanData = Array.isArray(response.data) ? response.data[0] : response.data;
                } else if (Array.isArray(response)) {
                    loanData = response[0];
                }

                if (loanData) {
                    const foundBranch = response?.branchName || response?.branch ||
                        response?.data?.branchName || response?.data?.branch ||
                        response?.branch_name || response?.bank_branch ||
                        response?.branchDto?.branchName || response?.branchDto?.name || "";
                    if (!loanData.branchName && foundBranch) {
                        loanData.branchName = foundBranch;
                    }
                }
            }

            if (loanData) {
                notification.success({
                    message: "Success",
                    description: `Loan details loaded for ${loanNo}`
                });
            } else {
                notification.info({
                    message: "Info",
                    description: "No specific details found, opening inquiry sheet."
                });
            }

            // Navigate to detail page
            navigate("/master/reports/loans/loan-payment-history", {
                state: {
                    loanData,
                    loanNo: loanNo.trim(),
                    branchName: loanData?.branchName || response?.branchName || response?.branch || "",
                    loginPlaceId,
                    branchId,
                }
            });
        } catch (error) {
            console.error("Error:", error);
            errHandler(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="panel-container">
            <Card hoverable className="inner-card">
                <Form layout="vertical">
                    <Row gutter={[16, 16]}>
                        <Col xs={24} sm={24} md={16} lg={12}>
                            <Form.Item
                                label="Loan Number"
                                required
                                validateStatus={error ? "error" : ""}
                                help={error}
                            >
                                <Input
                                    size="large"
                                    value={loanNo}
                                    onChange={handleLoanChange}
                                    placeholder="Enter Loan Number"
                                    allowClear
                                    onPressEnter={handleViewHistory}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <Form.Item className="generate-btn-outline">
                                <Button
                                    type="primary"
                                    onClick={handleViewHistory}
                                    disabled={loading || !loanNo.trim()}
                                    className="generate-btn"
                                    size="large"
                                    block
                                >
                                    {loading ? <Spin /> : 'View Details'}
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </div>
    );
};

export default LoanPaymentHistory;